import React from 'react';
import {
  CANVAS_WIDTH,
  CANVAS_HEIGHT,
  CERTIFICATE_FIELDS,
  parseLayoutConfig,
  getCertificateFieldText
} from '../../utils/certificateLayout';

const CertificateCanvas = ({ backgroundImageUrl, layoutConfig, data }) => {
  const layout = parseLayoutConfig(layoutConfig);

  return (
    <div
      className="relative overflow-hidden bg-white"
      style={{
        width: CANVAS_WIDTH,
        height: CANVAS_HEIGHT
      }}
    >
      {backgroundImageUrl && (
        <img
          src={backgroundImageUrl}
          alt=""
          className="absolute inset-0 w-full h-full object-contain pointer-events-none select-none"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      )}
      <div className="absolute inset-0">
        {CERTIFICATE_FIELDS.map((fieldKey) => {
          const config = layout[fieldKey];
          const text = getCertificateFieldText(fieldKey, data);
          if (!text || !config) return null;

          return (
            <div
              key={fieldKey}
              style={{
                position: 'absolute',
                left: `${config.x}px`,
                top: `${config.y}px`,
                fontSize: `${config.fontSize}px`,
                color: config.color || '#000000',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontWeight: fieldKey === 'title' ? 'bold' : 'normal',
                lineHeight: 1,
                transform: 'translateX(-50%)',
                whiteSpace: 'nowrap'
              }}
            >
              {text}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const CertificatePreviewFrame = ({ backgroundImageUrl, layoutConfig, data }) => {
  const wrapperRef = React.useRef(null);
  const [scale, setScale] = React.useState(1);

  React.useEffect(() => {
    const element = wrapperRef.current;
    if (!element) return undefined;

    const updateScale = () => {
      const nextScale = Math.min(1, element.clientWidth / CANVAS_WIDTH);
      setScale(nextScale > 0 ? nextScale : 1);
    };

    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapperRef} className="w-full flex justify-center">
      <div
        className="border border-gray-300 shadow-sm"
        style={{
          width: CANVAS_WIDTH * scale,
          height: CANVAS_HEIGHT * scale
        }}
      >
        <div
          style={{
            width: CANVAS_WIDTH,
            height: CANVAS_HEIGHT,
            transform: `scale(${scale})`,
            transformOrigin: 'top left'
          }}
        >
          <CertificateCanvas
            backgroundImageUrl={backgroundImageUrl}
            layoutConfig={layoutConfig}
            data={data}
          />
        </div>
      </div>
    </div>
  );
};

export default CertificateCanvas;
